module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('h1', {
    staticClass: "h1p"
  }, [_c('span', {
    attrs: {
      "aria-label": "8",
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak",
      "title": "8"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_vm._v("PART I")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-part"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781501155475/images/common01.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "part-bq"
  }, [_vm._v("Spirituality is always eventually")]), _vm._v(" "), _c('p', {
    staticClass: "part-bq"
  }, [_vm._v("about what you do with your pain.")]), _vm._v(" "), _c('p', {
    staticClass: "part-bqatt"
  }, [_vm._v("—Fr. Richard Rohr")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0868bd6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781501155475/xhtml/part01.vue
// module id = 81
// module chunks = 0